module.exports = __webpack_public_path__ + "static/img/32.299de05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/32.png
// module id = VAFf
// module chunks = 1